import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

const settingMenus = (): CloudPremisePluginMenu[] => {
    return [
        
    ];
};

export default settingMenus;